<template>
  <div>
    <b-modal
      ref="modal-landfill"
      centered
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
    >
      <template #modal-header="">
        <h5>REGISTER OF LANDFILLS</h5>
      </template>

      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Date:"
            label-for="fecha"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-datepicker
              id="example-datepicker"
              v-model="newlandfill.fecha"
              class="mb-2"
            ></b-form-datepicker>
          </b-form-group>
          <b-form-group
            label="Company:"
            label-for="company"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input
              id="company"
              v-model="newlandfill.company"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Weight TN:"
            label-for="weight"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="weight" v-model="newlandfill.peso"></b-form-input>
          </b-form-group>

          <b-form-group
            label="Amount $:"
            label-for="monto"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="monto" v-model="newlandfill.monto"></b-form-input>
          </b-form-group>

          <b-form-group
            label="Pay Method:"
            label-for="nrocc"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input
              id="nrocc"
              disabled
              v-model="newlandfill.nrocc"
            ></b-form-input>
          </b-form-group>
          <!--   <b-form-group
            label="Invoice Photo:"
            label-for="foto"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="foto" v-model="newlandfill.foto"></b-form-input>
          </b-form-group> -->
          <b-form-group
            label="Invoice:"
            label-for="invoice"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-input-group class="mt-3">
              <b-form-input></b-form-input>
              <b-input-group-append>
                <b-button variant="info">Take Photo</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="goHome()"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Landfills",
  data: function () {
    return {
      url: "https://www.imandrades.com/apiIMA/rutas.php?action=",
      isBusy: false,
      modalEditShow: false,
      modalAddShow: false,
      landfills: [],
      newlandfill: { fecha: new Date() },
      confirmDelete: "",
      currentlandfill: "GEORGIA",
    };
  },
  mounted() {
    this.$refs["modal-landfill"].show();
    this.leerLandfills();
  },
  methods: {
    leerLandfills: async function () {
      try {
        let respuesta = await axios.get(this.url + "getLandfills");
        this.landfills = respuesta.data.landfills;
      } catch (error) {
        console.log("Error Leyendo landfilles");
      }
    },

    goHome() {
      this.$refs["modal-landfill"].hide();
      this.$router.push("menuDesktop");
    },
    /* onRowSelected() {
      this.selected = items;
      console.log(this.selected);
    }, */

    showMsgSave() {
      this.boxTwo = "";
      this.modalEditShow = false;
      this.modalAddShow = false;
      this.$bvModal
        .msgBoxOk("Data was submitted successfully", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>


<style scoped>
.btnAdd {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.btnAdd:hover {
  transform: scale(1.2);
}
</style>